// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--3L5Rb";